import * as actionTypes from '../types/zdvl';

const initialState = {
  listZdvl: [],
  zdvlRolls: [],
  defaultCheckedRollsKeys: [],
  error: false,
  loading: false,
  okRequest: false,
  okRequestModal: false,
  okRequestTie: false,
  okRequestRid: false,
  okRequestClose: false,
  okRequestUpdateZDVL: false,
  okRequestZDVLSendNotice: false,
  loadingRolls: false,
  loadingZDVL: false,
  loadingModal: false,
  loadingClose: false,
  loadingUpdateZDVL: false,
  loadingZDVLSendNotice: false,
  statusData: null,
  visibleUpdateZDVL: false
};

const reducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case actionTypes.GET_ZDVL:
      return {
        ...state,
        okRequest: false,
        loadingData: true,
        loadingZDVL: true
      };
    case actionTypes.GET_ZDVL_SUCCESS:
      return {
        ...state,
        listZdvl: payload,
        okRequest: true,
        loadingData: false,
        loadingZDVL: false
      };
    case actionTypes.GET_ZDVL_FAIL:
      return {
        ...state,
        loadingData: false,
        loadingZDVL: false
      };
    case actionTypes.GET_ZDVL_ACCEPT:
    case actionTypes.GET_ZDVL_DECLINE:
    case actionTypes.GET_ZDVL_SEND:
      return {
        ...state,
        loadingModal: true,
        okRequestModal: false,
        error: false
      };
    case actionTypes.GET_ZDVL_ACCEPT_SUCCESS:
    case actionTypes.GET_ZDVL_DECLINE_SUCCESS:
    case actionTypes.GET_ZDVL_SEND_SUCCESS:
      return {
        ...state,
        loadingModal: false,
        okRequestModal: true,
        error: false
      };
    case actionTypes.GET_ZDVL_ACCEPT_FAIL:
    case actionTypes.GET_ZDVL_DECLINE_FAIL:
    case actionTypes.GET_ZDVL_SEND_FAIL:
      return {
        ...state,
        loadingModal: false,
        okRequestModal: false,
        error: true
      };
    case actionTypes.GET_ZDVL_CLEAR:
      return {
        ...state,
        error: false,
        loading: false,
        okRequest: false,
        okRequestModal: false,
        loadingModal: false
      };
    case actionTypes.GET_ZDVL_ROLLS:
      return {
        ...state,
        okRequest: false,
        loadingData: true,
        loadingRolls: true
      };
    case actionTypes.GET_ZDVL_ROLLS_SUCCESS:
      return {
        ...state,
        zdvlRolls: payload && payload.length
          ? payload
            .map((item) => ({
              ...item,
              quantityAvailable: item.quantityRemain !== null
                ? item.quantityRemain
                : item.quantity
            }))
          : payload,
        defaultCheckedRollsKeys: payload
          .filter((item) => item.checkbox !== 'NOT_SELECTED')
          .map(({ pieceNumId }) => pieceNumId),
        okRequest: true,
        loadingData: false,
        loadingRolls: false
      };
    case actionTypes.GET_ZDVL_ROLLS_FAIL:
      return {
        ...state,
        zdvlRolls: [],
        loadingRolls: false,
        loadingData: false
      };
    case actionTypes.TIE_ZDVL_ROLLS:
      return {
        ...state,
        okRequestTie: false,
        loadingData: true
      };
    case actionTypes.TIE_ZDVL_ROLLS_SUCCESS:
      return {
        ...state,
        listZdvl: state.listZdvl.map((item) =>
          item.zdvlLineNumId === payload.zdvlLineNumId
            ? ({
              ...item,
              capacityTied: Number(payload.rolls
                .reduce((acc, next) => acc + (next.checkbox === 'RELATED' || next.checkbox === 'RELATED_FIXED' ? next.weightNetto : 0), 0)
                .toFixed(2))
            }) : item),
        zdvlRolls: payload.rolls,
        defaultCheckedRollsKeys: payload.rolls
          .filter((item) => item.checkbox !== 'NOT_SELECTED')
          .map(({ pieceNumId }) => pieceNumId),
        okRequestTie: true,
        loadingData: false
      };
    case actionTypes.RID_ZDVL_ROLLS:
      return {
        ...state,
        okRequestRid: false,
        loadingData: true
      };
    case actionTypes.RID_ZDVL_ROLLS_SUCCESS:
      return {
        ...state,
        okRequestRid: true,
        loadingData: false
      };
    case actionTypes.RID_ZDVL_ROLLS_FAIL:
      return {
        ...state,
        okRequestRid: false,
        loadingData: false
      };
    case actionTypes.CLOSE_ZDVL:
      return {
        ...state,
        okRequestClose: false,
        loadingClose: true
      };
    case actionTypes.CLOSE_ZDVL_SUCCESS:
      return {
        ...state,
        okRequestClose: true,
        loadingClose: false
      };
    case actionTypes.CLOSE_ZDVL_FAIL:
      return {
        ...state,
        okRequestClose: false,
        loadingClose: false
      };
    case actionTypes.SET_ZDVL_LINE_STATUS_DATA:
      return {
        ...state,
        visibleUpdateZDVL: true,
        statusData: payload,
        okRequestUpdateZDVL: false
      };
    case actionTypes.UPDATE_ZDVL_MODAL_CLOSE:
      return {
        ...state,
        visibleUpdateZDVL: false
      };
    case actionTypes.UPDATE_ZDVL:
      return {
        ...state
      };
    case actionTypes.UPDATE_ZDVL_SUCCESS:
      return {
        ...state
      };
    case actionTypes.UPDATE_ZDVL_FAIL:
      return {
        ...state
      };
    case actionTypes.GET_ZDVL_SEND_NOTICE:
      return {
        ...state,
        loadingZDVLSendNotice: true,
        okRequestZDVLSendNotice: false,
        error: false
      };
    case actionTypes.GET_ZDVL_SEND_NOTICE_SUCCESS:
      return {
        ...state,
        loadingZDVLSendNotice: false,
        okRequestZDVLSendNotice: true,
        error: false
      };
    case actionTypes.GET_ZDVL_SEND_NOTICE_FAIL:
      return {
        ...state,
        loadingZDVLSendNotice: false,
        okRequestZDVLSendNotice: false,
        error: true
      };
    default:
      return state;
  }
};

export default reducer;
